import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { Container, Row, Col } from "react-bootstrap";

import groupSubscription from "../../../image/purchase/group-subscription.png";
import personalSubscription from "../../../image/purchase/personal-subscription.png";
import configSubscriptionCode from "../../../image/purchase/add-subscribtion-code.png";

import {ROUTE_PERSONAL_PURCHASE_PAGE,ROUTE_PURCHASE_SUBSCRIPTION_CODE,ROUTE_GROUP_PURCHASE} from "../../../routes"

import scrollToTop from "../../../libs/scrollToTop";

import { SubscriptionBackground, StyledCard } from "./styledPurchasePage";

const PurchasePageComponent = () => {
  const location = useLocation();

  useEffect(() => {
    scrollToTop();
    document.title = "خرید";
  }, []);
  return (
    <SubscriptionBackground>
      <Container className="pt-3 pb-3 pt-lg-4 pb-lg-5">
        <Row className="justify-content-center pt-3 pb-3 pt-lg-3 pb-lg-5">
          <Col xs={12} lg={3} className="w-auto m-3 order-3 order-md-1">
            <Link
              to={{
                pathname: ROUTE_PERSONAL_PURCHASE_PAGE,
                state: { prevPath: location.pathname },
              }}
            >
              <StyledCard className="pt-5 d-flex justify-content-start align-items-center">
                <p className="text-center mb-md-5">اشتراک شخصی</p>
                <img
                  src={personalSubscription}
                  alt="اشتراک شخصی"
                  className="image-fluid"
                />
              </StyledCard>
            </Link>
          </Col>
          <Col xs={12} lg={3} className="w-auto m-3 order-2">
          <Link
              to={{
                pathname: ROUTE_GROUP_PURCHASE,
                state: { prevPath: location.pathname },
              }}
            >
            <StyledCard className="pt-5 d-flex justify-content-start align-items-center">
              <p className="text-center mb-md-3">اشتراک گروهی</p>
              <img
                src={groupSubscription}
                alt="اشتراک گروهی"
                className="image-fluid"
              />
            </StyledCard>
            </Link>
          </Col>
          <Col xs={12} lg={3} className="w-auto m-3 order-1 order-md-3">
            <Link
              to={{
                pathname: ROUTE_PURCHASE_SUBSCRIPTION_CODE,
                state: { prevPath: location.pathname },
              }}
            >
              <StyledCard className="pt-5 d-flex justify-content-start align-items-center">
                <p className="text-center m-0 mb-md-3">ثبت کد اشتراک</p>
                <img
                  src={configSubscriptionCode}
                  alt="ثبت کد اشتراک"
                  className="image-fluid"
                />
              </StyledCard>
            </Link>
          </Col>
        </Row>
      </Container>
    </SubscriptionBackground>
  );
};

export default PurchasePageComponent;
